import React from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  Form,
  FormGroup,
  Input,
  Row,
  UncontrolledCollapse
} from "reactstrap";
import Select from "react-select";
import { Icon } from "@iconify/react";
import { v4 as uuidv4 } from "uuid";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import { selectGrowthPlan } from "redux/growPlanAssessment/selectors";
import TextLimitIndicator from "components/TextLimitIndicator";
import confirmationPopup from "utils/confirmationPopup";

export function checkHasError(field) {
  return field !== undefined && field !== "";
}

function Goals({ formik, handleNext, handleBack }) {
  const { goalsOptions } = useSelector(selectGrowthPlan);
  function addNewOutcomeHandler(goalName) {
    formik.setFieldValue(
      "goals",
      formik.values.goals.map((goal) => {
        if (goal.name === goalName) {
          return {
            ...goal,
            outComes: [
              ...goal.outComes,
              {
                id: uuidv4(),
                currentStatus: "",
                desiredStatus: ""
              }
            ]
          };
        }
        return goal;
      })
    );
  }

  function deleteOutcomeHandler(goalName, outcomeId) {
    formik.setFieldValue(
      "goals",
      formik.values.goals.map((goal) => {
        if (goal.name === goalName) {
          return {
            ...goal,
            outComes: goal.outComes.filter((outcome) => outcome.id !== outcomeId)
          };
        }
        return goal;
      })
    );
  }

  const goalsList = goalsOptions.map((goal) => ({
    value: goal,
    label: goal
  }));

  return (
    <div className="w-100 position-relative">
      <div>
        <div className="d-flex justify-content-start my-2 w-100">
          <h5>Select Goals</h5>
        </div>

        <Row className="mb-4">
          <Col lg="12">
            <FormGroup>
              <label>Goals *</label>
              <Select
                isMulti
                options={goalsList}
                name="goals"
                isClearable={false}
                value={formik.values.goals.map((goal) => ({
                  value: goal.name,
                  label: goal.name
                }))}
                // closeMenuOnSelect={false}
                onChange={async (e, action) => {
                  if (action.action === "select-option") {
                    formik.setFieldValue("goals", [
                      ...formik.values.goals,
                      {
                        name: action.option.value,
                        description: "",
                        priority: "",
                        outComes: [
                          {
                            id: uuidv4(),
                            currentStatus: "",
                            desiredStatus: ""
                          }
                        ],
                        duration: "",
                        personName: "",
                        actions: []
                      }
                    ]);
                  }
                  if (action.action === "remove-value") {
                    try {
                      const modalContent = `<h4 style="font-size:1.2rem;">Are you sure you want to remove Goal: <strong>${action.removedValue.value}</strong> from the list ?</h4>`;
                      const result = await confirmationPopup(modalContent);

                      if (result.isConfirmed) {
                        formik.setFieldValue(
                          "goals",
                          formik.values.goals.filter(
                            (goal) => goal.name !== action.removedValue.value
                          )
                        );
                      }
                    } catch (error) {
                      console.log("Error removing goal:", error);
                    }
                  }
                }}
              />
            </FormGroup>

            {formik.touched.goals && typeof formik.errors.goals === "string" ? (
              <div className="text-danger mt-2">{formik.errors.goals}</div>
            ) : null}
          </Col>
        </Row>
      </div>

      <div
        style={{
          maxHeight: "calc(100vh - 400px)",
          overflowY: "auto",
          overflowX: "hidden",
          paddingBottom: "20px"
        }}
        className="goals-list-container"
      >
        <div className="">
          <div
            className="accordion d-flex flex-column"
            style={{
              gap: "10px"
            }}
            id="accordionExample"
          >
            {(formik.values.goals || []).map((goal, index) => {
              return (
                <div
                  style={{
                    width: "100%",
                    border: "1px solid #ccc",
                    borderRadius: "5px"
                  }}
                  key={`${goal.name.replace(",", "").split(" ")[0]}`}
                >
                  <div
                    className="card-header"
                    id={`heading${goal.name.replace(",", "").split(" ")[0]}`}
                    style={{
                      backgroundColor: "#E7F1FD",
                      border: "none",
                      borderRadius: "5px"
                    }}
                  >
                    <button
                      className="btn btn-block text-left shadow-none d-flex justify-content-between align-items-center"
                      type="button"
                      data-toggle="collapse"
                      data-target={`#collapse${goal.name.replace(",", "").split(" ")[0]}`}
                      aria-expanded="true"
                      aria-controls={`collapse${goal.name.replace(",", "").split(" ")[0]}`}
                    >
                      <span>{goal.name}</span>

                      <Icon icon="mingcute:down-fill" width="24" height="24" color="#82828C" />
                    </button>
                  </div>

                  <UncontrolledCollapse
                    toggler={`#heading${goal.name.replace(",", "").split(" ")[0]}`}
                    defaultOpen={true}
                  >
                    <Card style={{ border: "none", borderRadius: "5px" }}>
                      <CardBody>
                        <Row>
                          <Col lg="12" className="mb-3">
                            <FormGroup className="position-relative mb-0">
                              <label htmlFor={`goals[${index}].description`}>
                                Goal Description *
                              </label>
                              <textarea
                                rows="4"
                                className="form-control"
                                placeholder="Enter Vision Statement"
                                id={`goals[${index}].description`}
                                name={`goals[${index}].description`}
                                value={goal.description}
                                onChange={(event) => {
                                  formik.setFieldValue(
                                    `goals[${index}].description`,
                                    event.target.value
                                  );
                                }}
                                onBlur={formik.handleBlur}
                                maxLength={1000}
                              />

                              <TextLimitIndicator current={goal.description?.length} limit={1000} />
                            </FormGroup>
                            {Array.isArray(formik.touched?.goals) &&
                            formik.touched.goals[index]?.description &&
                            Array.isArray(formik.errors?.goals) &&
                            formik.errors.goals[index]?.description ? (
                              <div className="text-danger mt-2">
                                {formik.errors.goals[index]?.description}
                              </div>
                            ) : null}
                          </Col>
                          <Col lg="12">
                            <FormGroup>
                              <label htmlFor={`goals[${index}].priority`}>Priority *</label>
                              <Input
                                type="select"
                                value={goal.priority}
                                id={`goals[${index}].priority`}
                                name={`goals[${index}].priority`}
                                onChange={(event) => {
                                  formik.setFieldValue(
                                    `goals[${index}].priority`,
                                    event.target.value
                                  );
                                }}
                                onBlur={formik.handleBlur}
                              >
                                <option value="" disabled>
                                  Select Priority
                                </option>
                                {["High", "Mid", "Low"].map((item) => (
                                  <option key={item} value={item}>
                                    {item}
                                  </option>
                                ))}
                              </Input>
                              {Array.isArray(formik.touched?.goals) &&
                              formik.touched.goals[index]?.priority &&
                              Array.isArray(formik.errors?.goals) &&
                              formik.errors.goals[index]?.priority ? (
                                <div className="text-danger">
                                  {formik.errors.goals[index]?.priority}
                                </div>
                              ) : null}
                            </FormGroup>
                          </Col>
                          <Col lg="12">
                            <Button
                              className="px-4 py-2 mt-4 border-0 shadow-none d-flex align-items-center justify-content-between"
                              style={{
                                gap: "10px",
                                color: "#000",
                                backgroundColor: "#F2F2F2"
                              }}
                              onClick={() => {
                                addNewOutcomeHandler(goal.name);
                              }}
                            >
                              <Icon icon="octicon:feed-plus-16" width="16" height="16" />
                              <span>Add</span>
                            </Button>
                            {formik.touched.goals &&
                              formik.touched.goals[index] &&
                              formik.touched.goals[index].outComes &&
                              goal.outComes.length === 0 && (
                                <div className="text-danger mt-2">
                                  At least one outcome is required for each goal.
                                </div>
                              )}
                          </Col>
                          {(goal.outComes || []).map((outcome, idx) => {
                            return (
                              <>
                                <Col lg="6" className="mt-3">
                                  <FormGroup className="position-relative mb-0">
                                    <label>Current Status {idx + 1} *</label>
                                    <textarea
                                      rows="4"
                                      className="form-control"
                                      placeholder="Enter Vision Statement"
                                      name={`goals[${index}].outComes[${idx}].currentStatus`}
                                      id={`goals[${index}].outComes[${idx}].currentStatus`}
                                      value={outcome.currentStatus}
                                      onChange={(event) => {
                                        formik.setFieldValue(
                                          `goals[${index}].outComes[${idx}].currentStatus`,
                                          event.target.value
                                        );
                                      }}
                                      onBlur={formik.handleBlur}
                                      maxLength={500}
                                    />

                                    <TextLimitIndicator
                                      current={outcome.currentStatus?.length}
                                      limit={500}
                                    />
                                    {Array.isArray(formik.touched?.goals) &&
                                    formik.touched.goals[index]?.outComes &&
                                    Array.isArray(formik.touched.goals[index].outComes) &&
                                    formik.touched?.goals[index]?.outComes[idx]?.currentStatus &&
                                    Array.isArray(formik.errors?.goals) &&
                                    formik.errors.goals[index]?.outComes &&
                                    Array.isArray(formik.errors?.goals[index]?.outComes) &&
                                    formik.errors?.goals[index]?.outComes[idx]?.currentStatus ? (
                                      <div
                                        className="text-danger"
                                        style={{
                                          position: "absolute",
                                          bottom: "-1.5rem"
                                        }}
                                      >
                                        {formik.errors.goals[index].outComes[idx]?.currentStatus}
                                      </div>
                                    ) : null}
                                  </FormGroup>
                                </Col>
                                <Col
                                  lg="6"
                                  className="mt-3 d-flex justify-content-between align-items-center"
                                  style={{ gap: "10px" }}
                                >
                                  <FormGroup className="w-100 position-relative">
                                    <label>Desired Outcome {idx + 1} *</label>
                                    <textarea
                                      rows="4"
                                      className="form-control"
                                      placeholder="Enter Vision Statement"
                                      name={`goals[${index}].outComes[${idx}].desiredStatus`}
                                      id={`goals[${index}].outComes[${idx}].desiredStatus`}
                                      value={outcome.desiredStatus}
                                      onChange={(event) => {
                                        formik.setFieldValue(
                                          `goals[${index}].outComes[${idx}].desiredStatus`,
                                          event.target.value
                                        );
                                      }}
                                      onBlur={formik.handleBlur}
                                      maxLength={500}
                                    />
                                    <TextLimitIndicator
                                      current={outcome.desiredStatus?.length}
                                      limit={500}
                                    />
                                    {Array.isArray(formik.touched?.goals) &&
                                    formik.touched.goals[index]?.outComes &&
                                    Array.isArray(formik.touched.goals[index].outComes) &&
                                    formik.touched.goals[index].outComes[idx]?.desiredStatus &&
                                    Array.isArray(formik.errors?.goals) &&
                                    formik.errors.goals[index]?.outComes &&
                                    Array.isArray(formik.errors.goals[index].outComes) &&
                                    formik.errors.goals[index].outComes[idx]?.desiredStatus ? (
                                      <div
                                        className="text-danger"
                                        style={{
                                          position: "absolute",
                                          bottom: "-1.5rem"
                                        }}
                                      >
                                        {formik.errors.goals[index].outComes[idx]?.desiredStatus}
                                      </div>
                                    ) : null}
                                  </FormGroup>

                                  <Icon
                                    icon="clarity:remove-solid"
                                    width="18"
                                    height="18"
                                    color="#82828C"
                                    onClick={() => deleteOutcomeHandler(goal.name, outcome.id)}
                                  />
                                </Col>
                              </>
                            );
                          })}
                        </Row>
                      </CardBody>
                    </Card>
                  </UncontrolledCollapse>
                </div>
              );
            })}
          </div>
        </div>

        <div className="d-flex justify-content-between mt-4">
          <button type="button" onClick={handleBack} className="btn btn-secondary">
            Back
          </button>
          <button
            type="button"
            onClick={async () => {
              formik.setTouched({
                goals: formik.values.goals.map((goal) => ({
                  name: true,
                  description: true,
                  priority: true,
                  outComes: goal.outComes.map((outcome) => ({
                    currentStatus: true,
                    desiredStatus: true
                  }))
                }))
              });

              formik.validateForm().then((response) => {
                if (checkHasError(response.goals)) {
                  toast("Please fill all the required fields before proceed further.", {
                    icon: "🚫"
                  });
                  return;
                } else {
                  handleNext();
                }
              });
            }}
            className="btn btn-primary"
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
}

export default Goals;
